import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const ErrorPage = ({ action, title, subtitle, icon }) => (
  <div className="large-12 columns error-page-container">
    <div className="error-page">
      <div key={0} className="row expanded error-content">
        <figure>
          <img alt="Error" src={`assets/img/${icon}`} />
        </figure>
        <div className="message">
          <span>{ title }</span>
          <span>{ subtitle }</span>
        </div>
      </div>
      { action &&
        <div className="row action-container">
          { action }
        </div>
      }
    </div>
  </div>
);

ErrorPage.propTypes = {
  action: PropTypes.node,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.any.isRequired,
  icon: PropTypes.string
};

ErrorPage.defaultProps = {
  action: null,
  icon: 'error404.png'
};

export default ErrorPage;
